<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Editar Usuario</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">

        <div class="card-body">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">

            <div class="row">
              <div class="col-6">
                <b-form-group id="input-group-3" label="Rol:" label-for="input-3">
                  <b-form-select
                    id="input-3"
                    v-model="form.role"
                    :options="roles"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-6">
              </div>
            </div>
            <b-button type="submit" variant="primary">Guardar</b-button>
          </b-form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AUTHORITIES } from "../../../../Utils/constants/global.constants";
import router from "../../../../router";

export default {
  data() {
    return {
      form: {
        role: null,
      },
      roles: [],
      show: true,
      isEdit: false,
      userId: '',
    }
  },
  methods: {
    loadRoles() {
      let loader = this.$loading.show({});
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/user/roles/list",
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          let arr = response.data;
          this.roles.push({text: 'Selecciona un rol', value: null})
          for (let item of arr) {
            let constant = item.name;
            this.roles.push({text: AUTHORITIES[constant], value: item.id})
          }
          loader.hide();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    onSubmit(event) {
      let loader = this.$loading.show({});
      event.preventDefault()
      if(this.isEdit) {
        axios.put(import.meta.env.VITE_API_BASE_URL + "/user/" + this.userId , this.form,{
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            }}).then((result) => {
          console.log(result);
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Usuario Editado."
          );
          loader.hide();
          router.push({ path: `/admin-panel/users` })
        }).catch((error) => {
          this.$toasted.error("No puedes editar un usuario con sesión activa.", {duration: 3000});
          console.log(error);
          loader.hide();
        });
      }

    },
    onReset(event) {
      event.preventDefault()
    }
  },
  mounted() {
    this.loadRoles();

    if (this.$route.params.id) {
      this.userId =this.$route.params.id;
      this.isEdit = true;
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/user/" + this.userId,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.form.role = response.data.roles[0].id;

        })
        .catch((err) => {
          console.log(err.message);
        });
    }
  }
}
</script>
